import ProviderAPI from "../../src/redux/ProviderAPI";
// import { api_provider } from "../../src/redux/ProviderAPI";

export const postBookingRental = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/saleorrent/addBookingRent",
    data: data,
  });

  return result;
};

export const getBookingRental = async (data) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/saleorrent/getBookingRent",
    data: data,
  });

  return result;
};

export const deleteBookingRental = async (data) => {
  const result = await ProviderAPI({
    type: "DELETE",
    url: "/saleorrent/deleteBookingRental",
    data: data,
  });

  return result;
};

export const editBookingRental = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/saleorrent/editBookingRent",
    data: data,
  });

  return result;
};

export const sendBookingDocument = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/saleorrent/sendEmailBooking",
    data: data,
  });

  return result;
};

export const addDocumentConfirmToDatabase = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/saleorrent/BookingRentalDocument",
    data: data,
  });

  return result;
};

export const editDocumentConfirmToDatabase = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/saleorrent/editBookingRentalDocument",
    data: data,
  });

  return result;
};

export const editStatusBookingRent = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/saleorrent/editStatusBookingRent",
    data: data,
  });

  return result;
};

export const addBookingRentalAgreement = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/saleorrent/addBookingRentAgreement",
    data: data,
  });

  return result;
};

export const getBookingRentalAgreement = async (data) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/saleorrent/getBookingRentAgreement",
    data: data,
  });

  return result;
};

export const getBookingRentalConfirm = async (data) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/saleorrent/getBookingRentalConfirm",
    data: data,
  });

  return result;
};

export const addBookingRentalRelates = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/saleorrent/addBookingRentRelates",
    data: data,
  });

  return result;
};

export const getBookingRentalRelates = async (data) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/saleorrent/getBookingRentalRelatesDoc",
    data: data,
  });

  return result;
};

export const deleteDocumentAgreementRent = async (data) => {
  const result = await ProviderAPI({
    type: "DELETE",
    url: "/saleorrent/deleteDocumentAgreementRent",
    data: data,
  });

  return result;
};

export const deleteDocumentRelatesRent = async (data) => {
  const result = await ProviderAPI({
    type: "DELETE",
    url: "/saleorrent/deleteDocumentRelatesRent",
    data: data,
  });

  return result;
};

export const editExtendStayRent = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/saleorrent/addExtendStay",
    data: data,
  });

  return result;
};

export const editRemarkCancelToBooking = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/saleorrent/editRemarkCancelToBooking",
    data: data,
  });

  return result;
};

export const sendEmailLawyerForRental = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/saleorrent/sendEmailLawyerForRental",
    data: data,
  });

  return result;
};

// Sales
export const addSales = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/saleorrent/addSale",
    data: data,
  });

  return result;
};

export const addSalesAgreement = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/saleorrent/addSalesAgreement",
    data: data,
  });

  return result;
};

export const addSalesRelates = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/saleorrent/addSaleRelatesDoc",
    data: data,
  });

  return result;
};

export const getSales = async (data) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/saleorrent/getSales",
    data: data,
  });

  return result;
};

export const getSalesAgreement = async (data) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/saleorrent/getSaleAgreement",
    data: data,
  });

  return result;
};

export const getSalesRelates = async (data) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/saleorrent/getSaleRelatesDoc",
    data: data,
  });

  return result;
};

export const editSales = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/saleorrent/editSale",
    data: data,
  });

  return result;
};

export const getRemarkSales = async (data) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/saleorrent/getRemarkSelling",
    data: data,
  });

  return result;
};

export const addRemarkSales = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/saleorrent/addRemarkSelling",
    data: data,
  });

  return result;
};

export const sendEmailSale = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/saleorrent/sendEmailSelling",
    data: data,
  });

  return result;
};

export const addDocConfirmSale = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/saleorrent/addDocumentConfirmSales",
    data: data,
  });

  return result;
};

export const getDocConfirmSales = async (data) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/saleorrent/getSaleConfirmDoc",
    data: data,
  });

  return result;
};

export const addPaymentTerm = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/saleorrent/addPaymentTerm",
    data: data,
  });

  return result;
};

export const getPaymentTerm = async (data) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/saleorrent/getPaymentTerm",
    data: data,
  });

  return result;
};

export const editPaymentTerm = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/saleorrent/editPaymentTerm",
    data: data,
  });

  return result;
};

export const deletePaymentTerm = async (data) => {
  const result = await ProviderAPI({
    type: "DELETE",
    url: "/saleorrent/deletePaymentTerm",
    data: data,
  });

  return result;
};

export const sendEmailLawyerForSelling = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/saleorrent/sendEmailLawyerForSelling",
    data: data,
  });

  return result;
};

export const deleteAgreementSale = async (data) => {
  const result = await ProviderAPI({
    type: "DELETE",
    url: "/saleorrent/deleteDocumentAgreementSale",
    data: data,
  });

  return result;
};

export const deleteRelateSale = async (data) => {
  const result = await ProviderAPI({
    type: "DELETE",
    url: "/saleorrent/deleteDocumentRelateSale",
    data: data,
  });

  return result;
};

export const deleteSellingDraft = async (data) => {
  const result = await ProviderAPI({
    type: "DELETE",
    url: "/saleorrent/deleteSellingDraft",
    data: data,
  });

  return result;
};
